// @vendors
import React from "react";
import { useTranslation } from "react-i18next";

// @types
import { Service } from "@/types/service.types";

// @components
import { Card } from "../atoms/Card";

interface ServiceCardProps {
  service: Service;
  onRequestClick: (service: Service) => void;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({ service, onRequestClick }) => {
  const { t } = useTranslation();

  return (
    <Card hoverable>
      <h3 className="text-[15px] font-semibold mb-2">{service.name}</h3>
      <p className="text-[14px] text-cTextSecondary dark:text-dark-cTextSecondary font-medium mb-2">
        {t("landingPage.topServicesHero.numberCompanies")}: 0
      </p> {/* {service.empresas} */}
      <p className="text-[12px] text-cTextSecondary dark:text-dark-cTextSecondary">
        {t("landingPage.topServicesHero.servicesDone")}: 0
      </p> {/* {service.numservices} */}
      <button
        onClick={() => onRequestClick(service)}
        className="mt-4 text-[14px] bg-bgBrand text-textOnBrand hover:bg-bgBrandHover px-4 py-2 rounded-lg"
      >
        {t("landingPage.topServicesHero.sendRequest")}
      </button>
    </Card>
  );
};
